import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showSendConsultNowInvitationModal } from 'actions/modal';
import { displayGlobalMessage } from 'actions/globalMessage';
import { sendConsultNowInvitation } from 'actions/waitingArea';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { PUBNUB_CHANNELS, subscribePubnubChannels } from '../../../../actions/pubnub/init';
import { getUserBasicProfile, userCallStatusUpdated } from '../../../../actions/user';
// import { redirectToPageNotFound, hideHelpAboutThisPage } from '../../../../actions/shared';

export default function RightPanelTop(props) {
  const dispatch = useDispatch();
  let [sendingInvitation, setSendingInvitation] = useState(false);
  let shouldBtnDisabled =
    props.formik.errors.firstName ||
    props.formik.values.firstName.trim() === '' ||
    props.formik.errors.lastName ||
    props.formik.errors.mobile ||
    props.formik.errors.email ||
    (props.formik.values.mobile.trim() === '' && props.formik.values.email.trim() === '');
  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  saveClasses = shouldBtnDisabled ? saveClasses + ' disabled' : saveClasses;

  const sendInvitation = () => {
    if (shouldBtnDisabled || sendingInvitation) {
      return;
    }
    let cb = (result, data, err) => {
      if (result) {
        props.setCurrentConsultNowTicketId(data.authTicketId);
        setSendingInvitation(false);
        subscribePubnubChannels([PUBNUB_CHANNELS.CONSULT_NOW + data.authTicketId]);
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.SendConsultNowInvitation.SuccessUpdateMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        props.setSendInvitationSuccessfully(true);
      }
      // TODO-HH - Custom error handling if required
      setSendingInvitation(false);
    };
    setSendingInvitation(true);
    let emailAddresses = props.parseEmailAddresses(props.formik.values.email);
    let payload = {
      firstName: props.formik.values.firstName,
      lastName: props.formik.values.lastName,
      email: emailAddresses[0],
      telephone: props.formik.values.mobile,
      ticketExpiryMins: 5,
    };
    dispatch(sendConsultNowInvitation(props.waitingArea.id, payload, cb));
  };

  return (
    <React.Fragment>
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <div className="ui actions mrbl max-width">
          <button
            tabIndex="5"
            type="button"
            data-group="sendConsultNowInvitation"
            className={sendingInvitation ? saveClasses + ' loading' : saveClasses}
            onClick={sendInvitation}
          >
            {APP.LANGUAGE.SendConsultNowInvitation.SendInvitation}
            <i className="send icon" />
          </button>
          <button
            tabIndex="6"
            type="button"
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
            onClick={() => dispatch(showSendConsultNowInvitationModal(false))}
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="display-flex flex-direction-column mrts mrbs max-width pdlm pdrm ">
          <button
            tabIndex="5"
            type="button"
            data-group="sendConsultNowInvitation"
            className={(sendingInvitation ? saveClasses + ' loading' : saveClasses) + ' mrbs'}
            onClick={sendInvitation}
          >
            {APP.LANGUAGE.SendConsultNowInvitation.SendInvitation}
            <i className="send icon" />
          </button>
          <button
            tabIndex="6"
            type="button"
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white mrts"
            onClick={() => dispatch(showSendConsultNowInvitationModal(false))}
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
    </React.Fragment>
  );
}
